import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BasicMetaData,
  PosRes,
  ReceiptContainerModel,
  ReceiptContainerModelExpectBackend,
  TemplateExpectBackend,
  TemplateModel, TYPE_SEARCH
} from 'shared';
import { PaginateQuery, PaginatorModel, UUID } from 'symbols';

@Injectable()
export class ReceiptsService {
  apiUrl = '/api/pax-terminal';

  constructor(private readonly http: HttpClient) {
  }

  pingTerminal(): Observable<PosRes> {
    return this.http.get<PosRes>(`${this.apiUrl}/ping`);
  }

  saleTerminal(amount: number): Observable<PosRes> {
    return this.http.post<PosRes>(`${this.apiUrl}/sale`, { amount });
  }


  getReceipts(filter?: PaginateQuery<{ searchText: string, typeSearch: TYPE_SEARCH }>): Observable<PaginatorModel<ReceiptContainerModel>> {
    const params: { [key: string]: any } = {
      page: filter?.page || 1,
      limit: filter?.limit || 50,
      sortBy: `${filter?.sortBy[0][0]}:${filter?.sortBy[0][1]}`,
      filter: filter?.filter,
      typeSearch: filter?.filter.typeSearch
    };


    params['search'] = filter?.filter?.searchText || '';

    return this.http.get<PaginatorModel<ReceiptContainerModel>>('/api/receipts', { params });
  }


  getReceiptListLazy(url: string): Observable<PaginatorModel<ReceiptContainerModel>> {
    return this.http.get<PaginatorModel<ReceiptContainerModel>>(url);
  }

  getTrafficById(id: string): Observable<ReceiptContainerModel> {
    return this.http.get<ReceiptContainerModel>(`/api/receipts/receipt/${id}`);
  }

  updateTraffic(id: UUID, traffic: ReceiptContainerModelExpectBackend, force = false): Observable<ReceiptContainerModel> {
    return this.http.patch<ReceiptContainerModel>(`/api/receipts/${id}`, traffic);
  }

  createTraffic(traffic: ReceiptContainerModelExpectBackend): Observable<ReceiptContainerModel> {
    return this.http.post<ReceiptContainerModel>(`/api/receipts`, traffic);
  }

  getTrafficTemplateList(): Observable<TemplateModel[]> {
    return this.http.get<TemplateModel[]>(`/api/receipts/traffic-template-list`);
  }


  updateTemplate(id: string, template: TemplateExpectBackend, name: string): Observable<TemplateModel> {
    return this.http.patch<TemplateModel>(`/api/receipts/traffic-template-list/${id}`, { ...template, name });
  }

  createTemplate(name: string, template: TemplateExpectBackend): Observable<TemplateModel> {
    return this.http.post<TemplateModel>(`/api/receipts/traffic-template-list/`, { ...template, name });
  }


  deleteTemplate(id: string): Observable<void> {
    return this.http.delete<void>(`/api/receipts/traffic-template-list/${id}`);
  }

  getNextMetaData(): Observable<BasicMetaData> {
    return this.http.get<BasicMetaData>(`/api/receipts/next-meta-data`);
  }
}
